import { removeIndustryUserToken } from "../../common";
import { industryUserTokenName } from "../../config";

const getIndustryFromLocalStorage = () => {
    try {
        const industry = JSON.parse(sessionStorage.getItem(industryUserTokenName));
        if (industry && industry.authToken && industry.loggedInTime) {
            return industry
        } else {
            removeIndustryUserToken();
            return null
        }
    } catch (error) {
        removeIndustryUserToken()
        return null
    }
};

const getInitial = () => {
    return getIndustryFromLocalStorage();
};

const industryuserReducer = (state = getInitial(), action) => {
    switch (action.type) {
        case "LOGIN_INDUSTRY_USER":
            const { loggedInTime, authToken } = action.payload;
            const newState = {
                loggedInTime: loggedInTime || Date.now(),
                authToken: authToken,
            };
            sessionStorage.setItem(industryUserTokenName, JSON.stringify(newState));
            return newState;
        case "LOGOUT_INDUSTRY_USER":
            removeIndustryUserToken();
            return null;
        default:
            return state;
    }
};

export default industryuserReducer;